




























































import { Component, Vue } from 'vue-property-decorator';
import { Loader } from '@googlemaps/js-api-loader';

declare const google: any;

const API_KEY = 'AIzaSyDujqMljusorewn_wIPBwS0CPSScU5o5ZQ';
@Component
export default class Contact extends Vue {
  public map: any;

  mounted() {
    this.loadMap();
  }

  loadMap() {
    new Loader({
      apiKey: API_KEY
    })
      .load()
      .then(() => {
        this.map = new google.maps.Map(document.getElementById('map'), {
          panControl: false,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          overviewMapControl: false,
          rotateControl: false,
          center: {
            lat: 49.141985,
            lng: 18.013351
          },
          zoom: 16
        });

        new google.maps.Marker({
          position: { lat: 49.141985, lng: 18.013351 },
          map: this.map,
          title: 'Hello World!'
        });
      })
      .catch(e => {
        console.log(e);
      });
  }
}
